import Devices from './tabs/Devices.vue'

export default {
  guid: 'b0bca8b297674792a6f4489d272b8230',
  tabs: [
    {
      name: 'Devices',
      component: Devices,
    },
  ],
}
